/**
 * Api available routes
 */

const auth = {
  login() {
    return 'public/login'
  },
  refreshToken() {
    return 'public/refresh-token'
  },
  register() {
    return 'public/registration'
  }
}

const users = {
  slug: 'users',
  clearSearchHistory: () => `${users.slug}/clear-search-history`,
  getAuthStatus: () => `${users.slug}/get-auth-status`,
  getCurrentUserDetails: () => `${users.slug}/get-current-user-details`,
  loginWithFacebook: () => `${users.slug}/facebook/login`,
  loginWithGoogle: () => `${users.slug}/google/login`,
  requestUserProfileReactivation: () =>
    `${users.slug}/request-user-profile-reactivation`,
  reactivateFacebookUserProfile: () =>
    `${users.slug}/facebook/reactivate-user-profile`,
  reactivateGoogleUserProfile: () =>
    `${users.slug}/google/reactivate-user-profile`,
  reactivateTwitterUserProfile: () =>
    `${users.slug}/twitter/reactivate-user-profile`,
  followTags: () => `${users.slug}/follow-tags`,
  unfollowTags: () => `${users.slug}/unfollow-tags`,
  followCategories: () => `${users.slug}/follow-categories`,
  unfollowCategories: () => `${users.slug}/unfollow-categories`,
  saveArticleForLater: () => `${users.slug}/save-article-for-later`,
  deleteSavedArticle: () => `${users.slug}/delete-saved-article`,
  clearAllSavedArticles: () => `${users.slug}/clear-all-saved-articles`,
  updateProfileInfo: () => `${users.slug}/update-profile-info`,
  saveSearchHistory: () => `${users.slug}/save-search-history`,
  getAuthor: () => `${users.slug}/get-author`,
  getAuthorArticles: () => `${users.slug}/get-author-articles`,
  followAuthors: () => `${users.slug}/follow-authors`,
  unfollowAuthors: () => `${users.slug}/unfollow-authors`,
  getProfileInfo: () => `${users.slug}/get-profile-info`,
  getProfileSettings: () => `${users.slug}/get-profile-settings`,
  deleteNotification: () => `${users.slug}/delete-notification`,
  getAllPosts: () => `${users.slug}/get-all-posts`,
  getSavedArticles: () => `${users.slug}/get-saved-articles`,
  getCompanies: () => `${users.slug}/get-companies`,
  getCompanyBySlug: () => `${users.slug}/get-company-by-slug`,
  renewCompany: () => `${users.slug}/renew-company`,
  renewCompanyFeatures: () => `${users.slug}/renew-company-features`,
  getCompanyState: () => `${users.slug}/get-company-state`,
  getSearchHistory: () => `${users.slug}/get-search-history`,
  deleteSearchHistoryRecords: () =>
    `${users.slug}/delete-search-history-records`,
  getPostBySlug: () => `${users.slug}/get-post-by-slug`,
  savePost: () => `${users.slug}/save-post`,
  updatePost: () => `${users.slug}/update-post`,
  deletePost: () => `${users.slug}/delete-post`,
  submitPost: () => `${users.slug}/submit-post`
}

const layout = {
  slug: 'layout',
  getHeaderMenuList: () => `${layout.slug}/get-header`,
  getFooterMenuList: () => `${layout.slug}/get-footer`,
  getTermsOfUse: () => `${layout.slug}/get-terms-of-use-page`,
  getPrivacyNotice: () => `${layout.slug}/get-privacy-notice-page`,
  getBecomeAContributerExpertises: () =>
    `${layout.slug}/get-become-a-contributor-expertises`,
  getSidebarMustReadItems: () => `${layout.slug}/sidebar/get-must-read-items`,
  getSidebarCryptocurrencyMustReadItems: () =>
    `${layout.slug}/sidebar/get-cryptocurrency-must-read-items`,
  getEbook: () => `${layout.slug}/get-ebook`,
  getTopBrokers: () => `${layout.slug}/top-brokers`,
  getAboutUs: () => `${layout.slug}/about-us-page`
}

const seo = {
  slug: 'seo',
  getRedirect: () => `${seo.slug}/get-redirect`,
  getPageSeo: () => `${seo.slug}/get-page-seo`
}

const directory = {
  slug: 'directory',
  createLead: () => `${directory.slug}/company/submit-contact-us-directly-lead`,
  uploadFmDirFile: () => `${directory.slug}/media/upload-file`,
  getFiltersByCategoryId: () => `${directory.slug}/get-filters-by-category-id`,
  createCompany: () => `${directory.slug}/create-company`,
  updateCompany: () => `${directory.slug}/update-company`,
  saveCompanyPreview: () => `${directory.slug}/save-company-preview`,
  uploadFlDirFile: () => `${directory.slug}/media/upload-file`
}

const directorySeo = {
  slug: 'directory/seo',
  getRedirect: () => `${directorySeo.slug}/get-redirect`,
  getPageSeo: () => `${directorySeo.slug}/get-page-seo`
}

const globalSearch = {
  slug: 'globalsearch',
  quickSearch: () => `${globalSearch.slug}/quick-search`,
  termsQuickSearch: () => `${globalSearch.slug}/terms-quick-search`,
  termsFullSearch: () => `${globalSearch.slug}/terms-full-search`,
  getAllResults: () => `${globalSearch.slug}/view-all-results`,
  tagsQuickSearch: () => `${globalSearch.slug}/tags-quick-search`,
  tagsFullSearch: () => `${globalSearch.slug}/tags-full-search`,
  companiesQuickSearch: () => `${globalSearch.slug}/companies-quick-search`
}

const directoryCompany = {
  slug: 'directory/company',
  getCompanyProfile: () => `${directoryCompany.slug}/get-company`,
  getCompanyPreview: () => `${directoryCompany.slug}/get-company-preview`,
  removeCompanyPreview: () => `${directoryCompany.slug}/remove-company-preview`
}

const directoryCategories = {
  slug: 'directory/categories',
  getCategoryFilters: () => `${directoryCategories.slug}/get-filters`,
  getCategoryCompanies: () => `${directoryCategories.slug}/companies`
}

const leads = {
  slug: 'leads',
  submitContactUsLead: () => `${leads.slug}/submit-contact-us-lead`,
  newsletterSubscription: () => `${leads.slug}/newsletter-subscription`,
  getSubscriptionSettings: () => `${leads.slug}/get-subscription-settings`,
  becomeAContributor: () => `${leads.slug}/become-a-contributor`,
  becomeAContributorFileUpload: () =>
    `${leads.slug}/become-a-contributor-file-upload`,
  submitEbookLead: () => `${leads.slug}/submit-ebook-lead`,
  verifyPhone: () => `${leads.slug}/verify-phone`
}

const videos = {
  slug: 'videos',
  uploadVideo: () => `${videos.slug}`,
  getVideo: () => `${videos.slug}`
}

const terms = {
  slug: 'terms',
  getTerm: () => `${terms.slug}/get-term`,
  getTermsByLetter: () => `${terms.slug}/get-terms-by-letter`,
  createUserSuggestion: () => `${terms.slug}/create-user-suggestion`
}

const tags = {
  slug: 'tags',
  getTag: () => `articles/get-tag`
}

const articles = {
  slug: 'articles',
  getAllNews: () => `${articles.slug}/get-all-news`,
  getArticleByTagSlug: () => `${articles.slug}/get-articles-by-tag-slug`,
  getArticleByTermSlug: () => `${articles.slug}/get-articles-by-term-slug`,
  getArticleByLegacySlug: legacySlug => `${articles.slug}/slugs/${legacySlug}`,
  getArticleContentBySlug: () => `${articles.slug}/get-article-content-by-slug`,
  getPreviewArticleContent: () =>
    `${articles.slug}/get-preview-article-content`,
  deletePreviewArticleContent: () =>
    `${articles.slug}/delete-preview-article-content`,
  getPreviewArticleEbook: () => `${articles.slug}/get-preview-article-ebook`,
  getArticlesByCategory: () => `${articles.slug}/get-articles-by-category`,
  getSessionWrapArticles: () => `${articles.slug}/get-session-wrap-articles`,
  getMostCommentedArticles: () => `${articles.slug}/get-most-commented-articles`
}

const categories = {
  slug: 'categories',
  getCategoryVideo: () => `${categories.slug}/get-category-video`,
  getSessionWrapsVideo: () => `${categories.slug}/get-session-wraps-video`,
  getAllNewsVideo: () => `${categories.slug}/get-all-news-video`
}

const assets = {
  slug: 'assets',
  getStocks: () => `${assets.slug}/stocks`,
  getStock: symbol => `${assets.slug}/stocks/${symbol}`
}

const media = {
  slug: 'media',
  uploadFlFile: () => `${media.slug}/upload-file`
}

const liveBytes = {
  slug: 'live-bytes',
  getLiveBytes: () => `${liveBytes.slug}`
}

const videoHosting = {
  slug: 'video-hosting',
  getYoutubeVideoData: externalId =>
    `${videoHosting.slug}/youtube/videos/${externalId}`
}

export default {
  auth,
  users,
  layout,
  seo,
  directory,
  globalSearch,
  directoryCompany,
  directoryCategories,
  leads,
  videos,
  terms,
  tags,
  articles,
  categories,
  directorySeo,
  assets,
  liveBytes,
  media,
  videoHosting
}
